import { ButtonSize } from "@tinyurldev/tu-ui-vue";

export function buildLongUrlInput({ copyProperties, inputProperties }) {
  const labelProperties = {
    id: "url",
    label: "Long URL",
    icon: "fa-solid fa-location-arrow",
    isRequired: true,
  };
  inputProperties = {
    id: "url",
    placeholder: "Paste Long URL Here",
    ref: "longUrlRef",
    ...inputProperties,
  };

  return {
    label: labelProperties,
    input: inputProperties,
    copy: copyProperties,
  };
}

export function buildDomainsInput({ copyProperties, inputProperties, domainOptions }) {
  const labelProperties = {
    id: "domain",
    label: "Domain",
    icon: "fa-solid fa-globe",
  };
  const bottomButtonProperties = {
    label: "Add Domain",
    type: "button",
    size: ButtonSize.MEDIUM,
  };

  return {
    placeholder: "Select a Domain",
    options: domainOptions,
    bottomButton: bottomButtonProperties,
    label: labelProperties,
    ...inputProperties,
    copy: copyProperties,
  };
}

export function buildAliasInput({ copyProperties, inputProperties }) {
  const labelProperties = {
    id: "alias",
    label: "Alias (Optional)",
    icon: "fa-solid fa-highlighter",
  };
  inputProperties = {
    id: "alias",
    placeholder: "Add Alias Here",
    ...inputProperties,
  };

  return {
    label: labelProperties,
    input: inputProperties,
    copy: copyProperties,
  };
}

export function buildTagInput({ copyProperties, inputProperties }) {
  const labelProperties = {
    id: "tag",
    label: "Add Tags (Optional)",
    icon: "fa-solid fa-tag",
  };
  inputProperties = {
    id: "tag",
    placeholder: "Enter Tag Name",
    ...inputProperties,
  };

  return {
    label: labelProperties,
    input: inputProperties,
    copy: copyProperties,
  };
}

export function disabledExpirationDateRange(date) {
  // get the current date
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);

  // add 5 years to the current date
  const futureDate = new Date(
    currentDate.getFullYear() + 5,
    currentDate.getMonth(),
    currentDate.getDate(),
  );

  return date < currentDate || date > futureDate;
}

export function disabledExpirationTimeRange(time) {
  const date = new Date(time);
  date.setSeconds(0);

  const start = new Date();
  start.setMinutes(start.getMinutes() + 5); // do not allow same minute
  start.setSeconds(59);

  return start && date < start;
}